import rewriteSrc from '~/utils/rewriteSrc';

// rewriteSrc's options parameter is a default, not a merge — passing { width }
// alone would drop the other options, so call sites go through this helper.
const DEFAULT_OPTIONS = {
  format: 'auto',
  fit: 'scale-down',
  quality: '80',
  onerror: 'redirect',
};

export const communityImageSrc = (src: string, width: number): string => {
  if (src.includes('/cdn-cgi/image/')) return src;

  return rewriteSrc(src, { ...DEFAULT_OPTIONS, width: String(width) });
};
